import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../config/api";
import {
  AppShell,
  CardPanel,
  PrimaryButton,
  PageHeader,
  TopbarActionGroup,
} from "../components";
import { clearClientSession, getAuthHeaders } from "../config/auth";

const HomePage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGenerateQR = async () => {
    setLoading(true);

    try {
      const response = await fetch(apiUrl("/api/qr/generate"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeaders(),
        },
      });

      const data = await response.json();

      if (response.ok && data.qrCode) {
        localStorage.setItem("generatedQRCode", data.qrCode);
        if (typeof data.qrLink === "string" && data.qrLink.trim()) {
          localStorage.setItem("generatedQRLink", data.qrLink);
        } else {
          localStorage.removeItem("generatedQRLink");
        }
        if (typeof data.manualCode === "string" && data.manualCode.trim()) {
          localStorage.setItem("generatedManualCode", data.manualCode);
        } else {
          localStorage.removeItem("generatedManualCode");
        }
        window.open("/QrPage", "_blank", "noopener,noreferrer");
      } else {
        alert("Failed to generate QR Code");
      }
    } catch (err) {
      console.error("Error generating QR Code:", err);
      alert("An error occurred while generating the QR Code.");
    } finally {
      setLoading(false);
    }
  };

  const handleSignOut = () => {
    clearClientSession();
    navigate("/");
  };

  return (
    <AppShell
      logoPosition="bottom"
      mainClassName="ui-shell__main--admin"
      topbarActions={<TopbarActionGroup onLogout={handleSignOut} />}
    >
      <PageHeader
        subtitle="Good Morning!"
        title="RCCG Praise Embassy Sunday School Dashboard"
      />

      <CardPanel className="ui-card-panel--wide ui-home-panel">
        <div className="ui-home-dashboard">
          <PrimaryButton
            className="ui-home-generate"
            onClick={handleGenerateQR}
            disabled={loading}
            size="lg"
          >
            <img src="/qr.png" alt="Generate QR" />
            <span>{loading ? "Generating..." : "Generate QR Code"}</span>
          </PrimaryButton>

          <div className="ui-home-tiles">
            <button
              type="button"
              className="ui-home-tile"
              onClick={() => navigate("/ManageAttendance")}
            >
              View Attendance
            </button>

            <button
              type="button"
              className="ui-home-tile"
              onClick={() => navigate("/ManageQuestions")}
            >
              View Question
            </button>

            <button
              type="button"
              className="ui-home-tile"
              onClick={() => navigate("/ManageStudentPage")}
            >
              Manage Students
            </button>
          </div>
        </div>
      </CardPanel>
    </AppShell>
  );
};

export default HomePage;
